import { render, staticRenderFns } from "./TableTreeviewItem.vue?vue&type=template&id=447515df&scoped=true&"
import script from "./TableTreeviewItem.vue?vue&type=script&lang=js&"
export * from "./TableTreeviewItem.vue?vue&type=script&lang=js&"
import style0 from "./TableTreeviewItem.vue?vue&type=style&index=0&id=447515df&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "447515df",
  null
  
)

export default component.exports